import { createAction, props } from '@ngrx/store';

export const setItemPackageAction = createAction(
  '[Confirm Package] Set Item Action',
  props<{ itemId: string; itemType: string; action: string; products?: any[] }>(),
);

export const resetPackageActions = createAction('[Confirm Package] Reset Actions');